import AxiosInstance from "../config/AxiosInstance";

export const getGeneralLedgerReport = async (page: any, limit: any, search: any, companyId: any, type: any, location: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/reports/GLReport', {
            params: {
                page: page,
                limit: limit,
                search: search,
                type: type,
                location: location
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getItemMovementReport = async (page: any, limit: any, search: any, companyId: any, type: any, location: any, userId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/reports/filterItemMovement', {
            params: {
                page: page,
                limit: limit,
                search: search,
                type: type,
                location: location,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

export const getListUser = async (companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/user-company/listUserWithCompany');
        return { data };
    } catch (error) {
        throw error;
    }
};